import { render, staticRenderFns } from "./companies-data-chart.vue?vue&type=template&id=490accdf&"
import script from "./companies-data-chart.vue?vue&type=script&lang=ts&"
export * from "./companies-data-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports